import { render, staticRenderFns } from "./SavePackage.vue?vue&type=template&id=729e5aea&"
import script from "./SavePackage.vue?vue&type=script&lang=js&"
export * from "./SavePackage.vue?vue&type=script&lang=js&"
import style0 from "./SavePackage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SavePackage.vue"
export default component.exports